import React from 'react'
import { async, fromJSX, Updater, Widget } from 'widgets-for-react'
import { State } from '../cmsPage.widget'
import { CmsFooterLayout } from './cmsFooter.layout'
import { hideTemplatePartial } from '../utils/layout'

export function publicSiteFooterWidget(currentState: State): Widget<Updater<State>> {
  const hideFooterNav: boolean = hideTemplatePartial('footer', currentState.rootModernBlocksState)
  const hideFooterShare: boolean = hideTemplatePartial('footer-share', currentState.rootModernBlocksState)

  return fromJSX((setState) => {
    return (
      <CmsFooterLayout.FooterWrapper hideFooterInfo={hideFooterShare}>
        {!hideFooterNav ? publicSiteFooter2levelWidget(currentState).run(setState) : <></>}
        <CmsFooterLayout.BottomNav />
      </CmsFooterLayout.FooterWrapper>
    )
  })
}

export function publicSiteFooter2levelWidget(currentState: State): Widget<Updater<State>> {
  const { copyrightMenuItems, menuItems } = currentState.CMSFooterState
  const hideDonationButton: boolean = hideTemplatePartial('donation', currentState.rootModernBlocksState)

  return fromJSX((setState) => (
    <>
      {async(menuItems).run((menuItemUpdater) => {
        setState((s) => ({
          ...s,
          CMSFooterState: { ...s.CMSFooterState, menuItems: menuItemUpdater(s.CMSFooterState.menuItems) },
        }))
      })}
      <CmsFooterLayout.Wrapper>
        {menuItems.kind == 'loaded' &&
        <CmsFooterLayout.footer2Level items={menuItems.value} displayType={currentState.CMSFooterState.displayType}>
          <CmsFooterLayout.Newsletter
            email={currentState.CMSFooterState.email}
            submitEmail={() => {
              if (currentState.CMSFooterState.email == undefined) return;
              window.location.assign("/nieuwsbrief" + "?email=" + encodeURIComponent(currentState.CMSFooterState.email))}}
            updateEmailInput={s => {
              setState(s0 => {
                let s1 = { ...s0, CMSFooterState: { ...s0.CMSFooterState } }
                s1.CMSFooterState.email = s
                return s1
              })
            }}
          />
        </CmsFooterLayout.footer2Level>
        }
        {/* <CmsFooterLayout.subFooter2Level hide={hideDonationButton}/> */}
      </CmsFooterLayout.Wrapper>
    </>
  ))
}
